import { render, staticRenderFns } from "./LabelGenIndex.vue?vue&type=template&id=f886c816"
import script from "./LabelGenIndex.vue?vue&type=script&lang=js"
export * from "./LabelGenIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports